import { z } from "zod";

const joinStringSourceSchema = z.object({
	id: z.string(),
	value: z.string(),
});
export type JoinStringSource = z.infer<typeof joinStringSourceSchema>;

export const joinStringsConfigurationSchema = z.object({
	targetField: z.string(),
	sourceExpressions: z.array(joinStringSourceSchema),
});
